/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import type { Listable, Pin, Property } from '@zcode/state-type'
import * as SourceC from '../../../../shared/constants/source'

// for rent path, we will be parsing feedName instead of relying on providerSource
// to handle consistencies across listable / buildings
export const isRentpath = (t: Listable | Property | Pin) =>
  !!t?.feedName?.includes(SourceC.RENTPATH)
